import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvEllipsis, pdvRadius, pdvShadow } from '../tokens';

export const useStyles = makeStyles({
  trigger: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    flex: 'none',
    width: 172,
    height: 40,
    padding: '8px 12px',
    border: `1px solid ${pdvColor.borderStrong}`,
    borderRadius: pdvRadius.pill,
    background: 'none',
    font: 'inherit',
    fontSize: 14,
    lineHeight: '20px',
    color: pdvColor.brand,
    cursor: 'pointer',
    '& span': pdvEllipsis,
    '& svg': { transition: 'transform .12s', transform: 'rotate(180deg)' },
    '&:focus-visible': { outline: 'none', borderColor: pdvColor.brand }
  },
  open: {
    borderColor: pdvColor.brand,
    '& svg': { transform: 'none' }
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: 320,
    maxHeight: 540,
    marginTop: 8,
    padding: '8px 12px',
    borderRadius: pdvRadius.l,
    background: pdvColor.surface,
    boxShadow: pdvShadow.menu
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    minHeight: 48,
    paddingLeft: 12,
    '& > span': {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      color: pdvColor.textHeading
    }
  },
  close: {
    display: 'grid',
    placeItems: 'center',
    width: 40,
    height: 40,
    padding: 8,
    border: 0,
    borderRadius: pdvRadius.pill,
    background: 'none',
    color: pdvColor.textSecondary,
    cursor: 'pointer',
    '&:hover': { background: pdvColor.surfacePage }
  },
  clear: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    padding: '4px 8px',
    border: 0,
    borderRadius: pdvRadius.pill,
    background: 'none',
    font: 'inherit',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    color: pdvColor.brand,
    cursor: 'pointer',
    '&:hover': { background: pdvColor.brandTint }
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'auto'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 4,
    minHeight: 40,
    padding: '8px 12px',
    border: 0,
    borderRadius: pdvRadius.pill,
    background: pdvColor.surface,
    font: 'inherit',
    fontSize: 14,
    lineHeight: '20px',
    color: pdvColor.textPrimary,
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover, &:focus-visible': {
      background: pdvColor.surfacePage,
      outline: 'none'
    }
  },
  itemOn: { color: pdvColor.brand },
  empty: { padding: 12, fontSize: 14, color: pdvColor.textSecondary }
});
